// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3plXQ","dragIcon":"Choice_dragIcon__274Se","left":"Choice_left__2eEfe","input":"Choice_input__34bM5"};